import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';

const EnterprisingIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="31.956"
      viewBox="0 0 22.352 31.956"
      y={props.yVal}
      x={props.xVal}
      fill={props.color}
      role="img"
    >
      <title>{t('Enterprising Icon')}</title>
      <path
        d="M39.7,54.226h.857V51.2a.432.432,0,0,1,.432-.432h2.578A.432.432,0,0,1,44,51.2v3.028h.857m0,0h8.6V29.159h0V23.541a.432.432,0,0,0-.432-.432h-3V22.7a.432.432,0,0,0-.432-.432H34.967a.432.432,0,0,0-.432.432v.432h-3a.432.432,0,0,0-.432.432v5.618h0V54.226h8.6m4.3-27.2v2.6a.432.432,0,0,1-.432.426H40.987a.432.432,0,0,1-.432-.426V27a.432.432,0,0,1,.432-.432h2.578A.432.432,0,0,1,44,27Zm2.578,2.158V27a.432.432,0,0,1,.432-.432h2.578a.432.432,0,0,1,.432.432v2.6a.432.432,0,0,1-.432.426H47.007a.432.432,0,0,1-.432-.426Zm-12.04,0V27a.432.432,0,0,1,.432-.432h2.578a.432.432,0,0,1,.432.432v2.6a.432.432,0,0,1-.432.426H34.967a.432.432,0,0,1-.432-.426ZM37.12,50.79Zm.857-4.967v1.945a.432.432,0,0,1-.432.432H34.967a.432.432,0,0,1-.432-.432v-2.6a.432.432,0,0,1,.432-.432h2.578a.432.432,0,0,1,.432.432Zm0-6.049v1.945a.432.432,0,0,1-.432.432H34.967a.432.432,0,0,1-.432-.432V39.1a.432.432,0,0,1,.432-.432h2.578a.432.432,0,0,1,.432.432Zm0-4.731v.65a.432.432,0,0,1-.432.432H34.967a.432.432,0,0,1-.432-.432V33.05a.432.432,0,0,1,.432-.432h2.578a.432.432,0,0,1,.432.432ZM44,45.8v1.945a.432.432,0,0,1-.432.432H40.987a.432.432,0,0,1-.432-.432V45.172a.432.432,0,0,1,.432-.432h2.578a.432.432,0,0,1,.432.432Zm0-6.049V41.7a.432.432,0,0,1-.432.432H40.987a.432.432,0,0,1-.432-.432V39.1a.432.432,0,0,1,.432-.432h2.578A.432.432,0,0,1,44,39.1Zm0-4.731v.65a.432.432,0,0,1-.432.432H40.987a.432.432,0,0,1-.432-.432V33.05a.432.432,0,0,1,.432-.432h2.578A.432.432,0,0,1,44,33.05ZM50.017,45.6v2.164a.432.432,0,0,1-.432.432H47.007a.432.432,0,0,1-.432-.432v-2.6a.432.432,0,0,1,.432-.432h2.578a.432.432,0,0,1,.432.432Zm0-6.049v2.164a.432.432,0,0,1-.432.432H47.007a.432.432,0,0,1-.432-.432V39.1a.432.432,0,0,1,.432-.432h2.578a.432.432,0,0,1,.432.432Zm0-3.885a.432.432,0,0,1-.432.432H47.007a.432.432,0,0,1-.432-.432V33.05a.432.432,0,0,1,.432-.432h2.578a.432.432,0,0,1,.432.432Z"
        transform="translate(-31.1 -22.27)"
      />
    </svg>
  );
};

export default EnterprisingIcon;

EnterprisingIcon.propTypes = {
  color: PropTypes.string.isRequired,
};
